import { FC } from "react";

import Box from "@mui/material/Box";

const MAX_BADGE_COUNT = 99;

interface UpcomingCountBadgeProps {
  count: number;
}

export const UpcomingCountBadge: FC<UpcomingCountBadgeProps> = ({ count }) => (
  <Box
    component="span"
    data-test="org-page-upcoming-events-count"
    sx={(theme) => ({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: theme.spacing(2),
      height: theme.spacing(2),
      paddingInline: 0.5,
      boxSizing: "border-box",
      borderRadius: theme.radius(9999),
      backgroundColor: theme.palette.forms.surface.moderate,
      color: theme.palette.forms.text.brand,
      ...theme.typography.caption,
    })}
  >
    {count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : count}
  </Box>
);
